export default function ApiDoc() {
	return(
<div className="nk-content">
  <div className="container-fluid">
    <div className="nk-content-inner">
      <div className="nk-content-body">
        <div className="nk-block vApiAbout">
          <div className="card card-bordered m-3 mb-4">
            <div className="card-inner-group">
              <div className="card-inner p-3">
                <div className="card">
                  <div className="row p-0 pointer">
                    <div className="col text-primary h5 m-0">소개</div>
                  </div>
                  <div
                    className="col-sm-12 col-md-12 bg-primary mt-2"
                    style={{
                      height: "1px",
                    }}
                  />
                  <div className="row">
                    <div className="col-sm-12 col-md-12 p-4">
                      API를 쉽고 편리하게 연동하고, 실제 테스트를 진행할 수 있는
                      방법과 정보를 제공하고 있습니다
                      <br />
                      <br />
                      <span className="text-azure fw-bold">심리스 API</span>
                      <br /> 당사로부터 게임 데이터만을 전달받고, 귀사가 직접
                      회원의 머니를 관리하는 방식입니다
                      <br /> 회원이 베팅을 하면 당사에서 귀사 서버로 베팅 금액
                      등의 정보를 실시간으로 전달하고, 귀사 서버에서 회원 머니를
                      직접 차감합니다
                      <br /> 심리스 API를 이용할 경우, 회원 머니 관리는 귀사
                      플랫폼에서 직접 이루어집니다
                      <br /> 이로 인해 베팅 정보를 즉각적으로 파악할 수 있으며
                      또한, 필요에 따라 베팅 거절, 금액 조정 등을 통해 베팅에
                      직접적으로 관여할 수 있는 장점이 있습니다
                      <br />
                      <span className="text-danger">
                        ※ 필수연동 : 공통 API, 심리스 API
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card card-bordered m-3 mb-4">
            <div className="card-inner-group">
              <div className="card-inner p-3">
                <div className="card">
                  <div className="row p-0 pointer">
                    <div className="col text-primary h5 m-0">연동순서안내</div>
                  </div>
                  <div
                    className="col-sm-12 col-md-12 bg-primary mt-2"
                    style={{
                      height: "1px",
                    }}
                  />
                  <div className="row">
                    <div className="col-sm-12 col-md-12 p-4">
                      연동 시 저희 API 문서에 명시된 연동 순서를 따르시기를
                      권장합니다
                      <br /> 각 페이지 내에 연동 순서가 기재되어 있습니다 각 API
                      페이지의 주의사항은 반드시 숙지한 후 진행하시기 바랍니다
                      <br />
                      <span className="text-danger">
                        카지노 스킨 한도 및 벤더사별 LOSE 데이터 전송 여부 는
                        부록 참고 부탁드립니다
                      </span>
                      <br />
                      <br />
                      <span className="badge bg-azure">Step 1</span>
                      <span className="text-azure fs-7 fw-bold">
                        공통 API 연동
                      </span>
                      <br /> 게임 종류 확인 및 유저 생성, 게임 실행까지의 과정을
                      진행합니다
                      <br />
                      <br />
                      <span className="badge bg-azure">Step 2</span>
                      <span className="text-azure fs-7 fw-bold">
                      심리스 API 연동
                      </span>
                      <br /> 심리스 방식의 경우 베팅, 승리, 패배 등의 거래를
                      처리하는 부분입니다.
                      <br />
                      <br />
                      <span className="badge bg-azure">Step 3</span>
                      <span className="text-azure fs-7 fw-bold">
                        데이터 API
                      </span>
                      <br /> 거래 내역, 라운드 상세 정보 등을 포함하는 부가적인
                      API입니다
                      <br /> 대부분 선택적으로 제공되며 필요하신 기능을
                      연동하시면 됩니다.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card card-bordered m-3 mb-4">
            <div className="card-inner-group">
              <div className="card-inner p-3">
                <div className="card">
                  <div className="row p-0 pointer">
                    <div className="col text-primary h5 m-0">
                      연동시 참고사항
                    </div>
                  </div>
                  <div
                    className="col-sm-12 col-md-12 bg-primary mt-2"
                    style={{
                      height: "1px",
                    }}
                  />
                  <div className="row">
                    <div className="col-sm-12 col-md-12 p-4">
                      <span className="text-azure fs-7 fw-bold">
                        1. 카지노 레벨별 베팅한도 확인
                      </span>
                      <br /> 당사에서 제공하는 카지노게임에는 베팅한도구간을
                      지정할 수 있는 스킨이 존재합니다
                      <br />
                      <span>
                        [부록 → 카지노 한도 스킨표]에서 각 스킨별 베팅 금액
                        구간을 확인하세요 그 후, 원하는 스킨을 사용해 주세요
                      </span>
                      <br />
                      <br />
                      <span className="text-azure fs-7 fw-bold">
                        2. LOSE 데이터 전송여부 확인
                      </span>
                      <br /> LOSE 데이터(패배결과) 전송여부는 게임사마다 차이가
                      있습니다
                      <br />
                      <span>
                        [부록 → 벤더사별 LOSE 데이터 전송 여부]에서 게임사별
                        LOSE 데이터 전송여부를 확인해주세요
                      </span>
                      <br />
                      <br />
                      <span className="text-azure fs-7 fw-bold">
                        3. 금액처리
                      </span>
                      <br />
                      <span className="text-danger">
                        금액처리시 무조건 실수형 으로 처리하셔야 합니다
                      </span>
                      <br />
                      <span className="text-danger">
                        정수형으로 처리시 소수점 단위가 처리되지않습니다
                      </span>
                      <br />
                      <br />
                      <span className="text-azure fw-bold">참고</span>
                      <br /> - 타임아웃
                      <br /> 모든 응답은 1.5초 이내에 처리 되어야 합니다
                      <br />
                      <br /> - 일반 API 와 콜백 API
                      <br /> 일반 API의 경우, 귀사가 당사 플랫폼으로 요청을 하고
                      응답을 받습니다
                      <br /> 콜백 API는 당사 플랫폼이 귀사로 요청을 하고
                      당사에서 응답을 받습니다
                      <br /> 게임사에 따라 상세 정보가 2초에서 15초 후에 당사로
                      전송됩니다 이로 인해 게임 결과의 상세 내역을 실시간으로
                      받지 못하는 경우가 발생할 수 있습니다
                      <br /> 당사는 실시간으로 상세 내역을 전송하지만,
                      게임사에서 결과 전송이 지연되는 경우를 대비해 2-15초 후에
                      상세 내역을 수신하는 것을 권장합니다
                      <br />
                      <br />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
	)
}